import { render, staticRenderFns } from "./FinalStep.vue?vue&type=template&id=2498e020&scoped=true&"
import script from "./FinalStep.vue?vue&type=script&lang=js&"
export * from "./FinalStep.vue?vue&type=script&lang=js&"
import style0 from "./FinalStep.vue?vue&type=style&index=0&id=2498e020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498e020",
  null
  
)

export default component.exports